export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-mail-send-line"></i>
            期待你的声音
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            投稿与咨询
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
            如果你有优质的韩漫推荐、原创漫评投稿，或是对香香漫画有任何建议与反馈，欢迎通过以下方式联系我们。我们珍视每一位读者的声音，期待与你一起打造更好的韩漫阅读社区。
          </p>

          <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
            <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-xl text-primary-500"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-500 mb-0.5">投稿 / 合作 / 问题反馈</div>
              <div className="text-sm font-semibold text-foreground-900">manga@xiangxiang.com</div>
            </div>
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              发送邮件
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}